// Feather entry (DR-0045 D4): legacy/foreign routes (the old single-app wave
// URLs like /#/wave-solo?ai=zombie) redirect to their page BEFORE the engine
// boots — the hash (query included) is carried over wholesale. Everything else
// lazy-loads the real boot module, keeping the redirect path near-zero cost.
import { FOREIGN_ROUTES } from "./routes";

const route = location.hash.replace(/^#\//, "").trim().split("?")[0] ?? "";
const foreignBase = FOREIGN_ROUTES[route];
if (foreignBase) {
  location.replace(`${foreignBase}${location.hash}`);
} else {
  void import("./boot");
}
